export default function ProcessDiagram({ steps, accent = "ink" }) {
  const nodeBg = accent === "mint" ? "bg-mint text-ink" : "bg-ink text-mint";
  return (
    <div className="relative" data-testid="process-diagram">
      <div
        aria-hidden
        className="absolute left-6 top-2 bottom-2 border-l-2 border-dashed border-ink-200 z-0"
      />
      <ol className="space-y-10 md:space-y-14 relative">
        {steps.map((step, idx) => (
          <li
            key={idx}
            data-testid={`process-step-${idx + 1}`}
            className="grid grid-cols-[3rem_1fr] gap-5 md:gap-8 items-start"
          >
            <div
              className={`relative z-10 w-12 h-12 rounded-full ${nodeBg} flex items-center justify-center font-headings text-lg`}
            >
              {String(idx + 1).padStart(2, "0")}
            </div>
            <div className="pt-1.5">
              <p className="text-xs uppercase tracking-[0.2em] text-stone-dark font-medium mb-2">
                {step.overline || `Step ${idx + 1}`}
              </p>
              <h3 className="font-headings text-2xl md:text-3xl text-ink leading-tight mb-3">
                {step.title}
              </h3>
              <p className="font-body text-ink-700 leading-relaxed max-w-xl">{step.body}</p>
            </div>
          </li>
        ))}
      </ol>
    </div>
  );
}
